import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import NavBar from "../components/NavBar";

interface AxiosError {
    response?: {
      data: any;
      status: number;
      statusText: string;
    };
    request?: any;
    config?: {
      baseURL: string;
      method: string;
      url: string;
    };
    message?: string;
  }

function Error() {
    const error = useRouteError() as AxiosError;

    return (
        <>
            <NavBar />
            <div>
                <h5>Error page</h5>
                <hr className="mt-1" />
                { isRouteErrorResponse(error) ?
                    ("Page doesn't exists") :
                    error.response ? (
                        <div>
                            <h6>Server Message:</h6>
                            <pre style={{ marginBottom: "0px" }}>
                                {JSON.stringify(error.response.data, null, 2)}
                            </pre>
                        </div>
                    ) : error.request ? (
                        <div>
                            <h6>Request Error:</h6>
                            <p>Requisition was done but didn't had server answer.</p>
                            {
                                error.config ? (
                                    <div>
                                        <p>
                                            <strong>base URL:</strong> {error.config.baseURL}
                                            <br />
                                            <strong>Method:</strong> {error.config.method}
                                            <br />
                                            <strong>URL:</strong> {error.config.url}
                                            <br />
                                        </p>
                                    </div>
                                ) : (
                                    ""
                                )
                            }
                        </div>
                    ) : (
                        <div>
                            <h6>Error Message:</h6>
                            <p>{error.message || "Unknown Error"}</p>
                        </div>
                    )

                }
            </div>
        </>
    )
}

export default Error;